module.exports = __webpack_public_path__ + "static/Repairers-4bd3da35f8026b212f9374584cce7303.svg";